import { Rota } from '@finx/web-repository/src/types/Rotas'

const rotas: Array<Rota> = [
  {
    hideOnMobile: true,
    icone: 'receipt',
    texto: 'Agendamento',
    url: '/agendamento-medico',
    viewName: 'agendamento-medico',
  },
  {
    icone: 'account_box',
    texto: 'Perfil',
    url: '/perfil',
    viewName: 'perfil',
  },
]

export default rotas
